import React, { useState } from "react";
import { validator } from "web3-validator";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";

const WalletAddress = ({
  isLoading,
  maticAddress,
  setMaticAddress,
  onSubmit,
}) => {
  const [isValid, setIsValid] = useState(null);
  const [captchaValue, setCaptchaValue] = useState(null);
  const [errMsg, setErrMsg] = useState(null);

  const PMEAddress = "0xFD1eEb2f3399872735f3Df735816c4FC607E12C4";
  const isValidMaticAddress = (address) => {
    try {
      validator.validate(["address"], [address]);
      if (address === PMEAddress) {
        setErrMsg("PME address is not acceptable");
        return false;
      } else return true;
    } catch (error) {
      return false;
    }
  };
  const handleMaticAddressChange = (event) => {
    const { value } = event.target;
    setMaticAddress(value);
    setIsValid(isValidMaticAddress(value));
  };
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast.success("Copied to clipboard!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        // transition: Bounce,
      });
    });
  };
  const onChange = (value) => {
    setCaptchaValue(value);
  };

  return (
    <div className="form-card">
      <h3>Enter your Polygon / Matic address to get PME</h3>
      <div className="form-box">
        <div className="input-box">
          <input
            type="text"
            value={maticAddress}
            onChange={handleMaticAddressChange}
            className={`input ${
              isValid !== null ? (isValid ? "is-valid" : "is-invalid") : ""
            }`}
          />
          {isValid !== null && (
            <p className={`input-msg ${isValid ? "is-valid" : "is-invalid"}`}>
              {isValid
                ? "Valid Matic Address"
                : errMsg ?? "Invalid Matic Address"}
            </p>
          )}
        </div>
        <div className="">
          <h3>Please Add PME Smart Contract To Your Wallet:</h3>
          <div
            className="input-button"
            onClick={() => copyToClipboard(PMEAddress)}
          >
            <input type="text" value={PMEAddress} readOnly />
            <button>copy</button>
          </div>
        </div>
      </div>
      <ReCAPTCHA
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
        onChange={onChange}
      />
      <button
        onClick={onSubmit}
        disabled={!isValid || !captchaValue}
        className="spin-btn"
        style={{ display: "flex", margin: "24px auto 0" }}
      >
        {isLoading ? (
          <ul className="button__loading ">
            <li></li>
            <li></li>
            <li></li>
          </ul>
        ) : (
          "Get Reward"
        )}
      </button>
    </div>
  );
};

export default WalletAddress;
